import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Footer.css';

function Footer() {
  // Coordinates for the map
  // const mapCoordinates = "11.110864096730555,76.93647371480003";
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo">Timeless Home Care</div>
            <p className="footer-description">
              Providing compassionate home care services with dignity and respect for seniors and their families.
            </p>
            <div className="social-icons">
              <a 
                href="https://www.facebook.com/share/16p1idZJJd/" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a 
                href="https://www.instagram.com/timeless_homecare?igsh=em42bGpkc2tsMDV4" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a 
                href="https://wa.me/918270007174" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="WhatsApp"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
              <a 
                href="mailto:timelesshomecareservice@gmail.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Email"
              >
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>
          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              {/* <li><Link to="/faq">FAQ</Link></li> */}
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Contact Information</h3>
            <ul className="footer-links contact-info">
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>220/1c Indranagar Narasimhanaickenpalayam, near old EB office, Coimbatore, Tamil Nadu 641031</span>
              </li>
              <li>
                <i className="fas fa-phone"></i>
                <a href="tel:8270007174" className="phone-link">827 000 7174</a>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@timelesshomecare.com" className="email-link">info@timelesshomecare.com</a>
              </li>
            </ul>
          </div>
          <div className="footer-column map-column">
            <h3>Find Us</h3>
            <div className="map-container">
              <iframe 
                title="Google Maps"
                src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.317846719748!2d76.93388501479657!3d11.110864096730555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDA2JzM5LjEiTiA3NsKwNTYnMTEuMyJF!5e0!3m2!1sen!2sin!4v1629876543210!5m2!1sen!2sin`}
                allowFullScreen="" 
                loading="lazy">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;